import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Popover from '@mui/material/Popover';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import NOLItemList from '/@/components/new-overlay-list/item-list';
import settings from '/@/core/settings';
import useOverlayConfig from '/@/hooks/my-recommendations/useOverlayConfig';
import { _ } from '/@/locale';
import { setSelectedFeature } from '/@/store/nav/actions';
import { reverse } from '/@/utils/router';
import CreateRecommendationModal from '../../../views/dashboard/rv/components/create-recommendation-modal';
import styles from '../styles.module.css';

const ActionsButtons = ({ step, filterRecos, setFilterRecos, setStep, showButtonDeleteRecos }) => {
    const [showButtonRecos, setShowButtonRecos] = useState(true);
    const [disabledButtonApply, setDisabledButtonApply] = useState(true);
    const [anchorEl, setAnchorEl] = useState(null);
    const history = useNavigate();
    const dispatch = useDispatch();
    const setSelectedFeatureAction = bindActionCreators(setSelectedFeature, dispatch);
    const overlayConfig = useOverlayConfig();
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    const applyMobileFilters = () => {
        setStep('step3');
    };

    useEffect(() => {
        setShowButtonRecos(step === 'step2');
    }, [step]);

    useEffect(() => {
        const foundKeys = Object.keys(filterRecos).some((key) => filterRecos[key] !== undefined);
        setDisabledButtonApply(!foundKeys);
    }, [filterRecos]);

    const handleClean = () => {
        setDisabledButtonApply(true);
        setFilterRecos({});
    };

    const handleClickNewReco = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseNewReco = () => {
        setAnchorEl(null);
    };

    const handleClickReco = (e) => {
        const data = { view: 'Home', selectedFeature: 'recommendation', crop: e.type };
        setSelectedFeatureAction(data);
        history(reverse(data.view));
    };

    return (
        <Grid item xs={12} className={styles.fixedBottom}>
            {!showButtonRecos ? (
                <Grid container justifyContent='center'>
                    {showButtonDeleteRecos && (
                        <Grid item xs={11}>
                            <Button fullWidth variant='outlined' color='error'>
                                {_('Eliminar Recomendación/es')}
                            </Button>
                        </Grid>
                    )}
                    {overlayConfig.length > 0 && (
                        <Grid item xs={11}>
                            <Button fullWidth variant='contained' onClick={handleClickNewReco}>
                                {_('Crear Nueva Recomendación')}
                            </Button>
                            <CreateRecommendationModal
                                open={open && settings.app.theme === 'expertobayer'}
                                setOpen={setAnchorEl}
                                entrySource='recommendation-list'
                            />
                            <Popover
                                id={id}
                                open={open && settings.app.theme !== 'expertobayer'}
                                anchorEl={anchorEl}
                                onClose={handleCloseNewReco}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'center',
                                }}
                            >
                                <NOLItemList itemList={overlayConfig} selectItem={handleClickReco} myRecommendations />
                            </Popover>
                        </Grid>
                    )}
                </Grid>
            ) : (
                <Grid container justifyContent='center' spacing={2}>
                    <Grid item xs={11}>
                        <Button
                            fullWidth
                            disabled={disabledButtonApply}
                            variant='contained'
                            onClick={applyMobileFilters}
                        >
                            {_('Aplicar')}
                        </Button>
                    </Grid>
                    <Grid item xs={11}>
                        <Button fullWidth disabled={disabledButtonApply} variant='outlined' onClick={handleClean}>
                            {_('Limpiar')}
                        </Button>
                    </Grid>
                </Grid>
            )}
        </Grid>
    );
};

export default ActionsButtons;
